import axios from 'axios'
import Slider from '../components/Slider'
import Tweet from '../components/Tweet'
import momentFormat from '../mixins/momentFormat'
import {apiEnv} from '../env.js'
import {ticketEnv} from '../env.js'

var apiPath = apiEnv()
var ticketPath = ticketEnv()

export default {
  components: {
    Slider,
    Tweet
  },
  data () {
    return {
      loaded: false,
      ticketAlart: '',
      ticketInfo: '',
      film: {},
      ticketPath: ticketPath,
      showSlide: true,
      showTweet: true
    }
  },
  mixins: [momentFormat],
  methods: {
		getData (id) {
			let params = {
				official_site: true
			}
			axios
				.get(apiPath + '/films/' + id, { params })
				.then((res) => {
					this.insertMeta(res)
          this.searchShowSeatsFlag(res.data)
					this.film = res.data
					console.log(res.data)
					this.showSlide = true
          if (typeof LineIt) LineIt.loadButton()
				}).catch((error) => {
          if(error.response.status == 500) this.redirectList()
					this.loaded = true
				})
		},
    searchShowSeatsFlag (data) {
      if (data.acts.length && data.acts[0].is_show_seats) {
        data.is_show_seats = true
      }
    },
    slideImageLoaded () {
      if(this.film.video_identifier || this.film.image_num > 1) {
        window.setTimeout(() => {
          let slide = $('#maincutSlide').bxSlider({
            pagerCustom: '#customThumb'
          })
          window.setTimeout(() => {
            this.loaded = true
          }, 10 )
        }, 100 )
      } else {
        $('#customThumb a').addClass('disabled')
        this.loaded = true
      }
    }
  },
	watch: {
		'$route' (to, from) {
			this.loaded = false
			this.showSlide = false
			this.getData(to.params.id)
      //TweetComponentを再描画するために一度削除
      this.showTweet = false
		}
	},
  created () {
		if (this.$route.params.id) this.getData(this.$route.params.id)
		else this.redirectList()
	},
  updated (){
    //TweetComponentを再描画
    this.showTweet = true
  }
}



// WEBPACK FOOTER //
// ./src/mixins/film.js